export const accessScopes = {
  INDEX: 'event.index',
  ACCEPT: 'event.accept',
  ACCEPT_CHANGE: 'event.accept.change',
  REJECT: 'event.reject',
  REJECT_CHANGE: 'event.reject.change',
  SHOW: 'event.show',
  REPORT: 'event.report',
  CAMERA_INDEX: 'camera.index',
  USER_INDEX: 'user.index',
  ZONE_INDEX: 'zone.index',
  ACTIVITY_INDEX: 'activity.index',
  TEST: 'unknown'
}
